import { z } from 'zod';

const str = z.string().nullable().default(null);

export const ArchivioSchema = z.object({
  id: z.number(),
  codFiscale: z.string(),
  // Schema multi-cassa: una riga per (codFiscale, codiceCassa); la cassa
  // della riga e' fissa, e codiceLavCassa contiene il codice del lavoratore
  // in quella cassa (null/vuoto = "in attesa di codifica").
  codiceCassa: str,
  codiceLavCassa: str,
  datapres: str,
  cognNome: str,
  indirizzo: str,
  citta: str,
  prov: str,
  cap: str,
  telefono: str,
  note: str,
  operatore: str,
  origine: z.string().default('IMPORT'),
});

export type Archivio = z.infer<typeof ArchivioSchema>;

export interface ArchivioInsert {
  codFiscale: string;
  cognNome: string | null;
  indirizzo: string | null;
  citta: string | null;
  prov: string | null;
  cap: string | null;
  telefono: string | null;
  note: string | null;
  operatore: string | null;
  dataNascita: string | null;
}
